var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.75C0 0.335786 0.335786 0 0.75 0H9C9.41421 0 9.75 0.335786 9.75 0.75C9.75 1.16421 9.41421 1.5 9 1.5H1.5V16.5H16.5V9C16.5 8.58579 16.8358 8.25 17.25 8.25C17.6642 8.25 18 8.58579 18 9V17.25C18 17.6642 17.6642 18 17.25 18H0.75C0.335786 18 0 17.6642 0 17.25V0.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.75v3.5c0 .41.34.75.75.75s.75-.34.75-.75v-3.5h3.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3.5V.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.5h-3.5c-.41 0-.75.34-.75.75s.34.75.75.75h3.5Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewItem);
export default __webpack_public_path__ + "static/media/new-item.8cb5d846ed93b51238ce3ecceb1f86ab.svg";
export { ForwardRef as ReactComponent };